export default {
  name: 'marking--aggrM',
  apiService: 'shoes',
  apiPath: '/admin/aggr_m',
};